<template>
  <div id="app">
    <div v-show="!globalLoading">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
      <Footer_nav v-if="flag"/>
    </div>
    <div v-if="globalLoading" class="loading">
      <van-loading size="1rem"></van-loading>
    </div>
  </div>
</template>

<script>
  import Footer_nav from "./components/Footer_nav";
  import {mapState} from 'vuex'
  import {Loading} from 'vant'

  export default {
    name: 'App',
    components: {Footer_nav,[Loading.name]:Loading},
    computed:{
      ...mapState(['globalLoading'])
    },
    data(){
      return {
        flag:true
      }
      
    },
    created(){
      var str = window.location.href
      if(str.includes('publichome')==true||str.includes('homedetail')||str.includes('coursedetail')||str.includes('teacher')||str.includes('agreement')){
        this.flag = false
      }else{
        this.flag = true
      }
	  this.flag = true
    }
  }
</script>

<style lang="stylus" scoped>
  .loading
    width: 10rem;
    height :100vh;
    display: flex;
    align-items: center;
    justify-content: center
</style>
<style lang="stylus">
img[lazy='error'],img[lazy='loading']
  width 25px
  height 25px
</style>
